import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import Communication from './communication';
import CounterExpertise from './counter-expertise';
import Remark from './remark';
import SvsLines from './svs-lines';
import SvsSideNav from './svs-side-nav';
import { SvsViews } from '../../../../store/details/svs/model';
import Signing from './signing';
import ValueAndCause from './value-and-cause';
import VatAndPayment from './vat-and-payment';
import SvsList from './svs-list';
import { connect } from 'react-redux';
import styles from './svs.module.css';
import withParams from '../../../common/withParams';

interface PropsFromState {
  readonly currentView: SvsViews;
}

type AllProps = PropsFromState & ConnectedReduxProps & {
  params: {
    instructionId: number;
  };
};

class Svs extends React.Component<AllProps> {
  private get selectedPage() {
    switch (this.props.currentView) {
      case SvsViews.valueAndCause:
        return <ValueAndCause {...this.props} />;
      case SvsViews.svsLines:
        return <SvsLines {...this.props} />;
      case SvsViews.vatAndPayment:
        return <VatAndPayment {...this.props} />;
      case SvsViews.counterExpertise:
        return <CounterExpertise {...this.props} />;
      case SvsViews.signing:
        return <Signing {...this.props} />;
      case SvsViews.remark:
        return <Remark {...this.props} />;
      case SvsViews.communication:
        return <Communication {...this.props} />;
      default:
        return <div/>;
    }
  }

  public render() {
    return (
      <div className={styles.container}>
        <div className={styles.svscontent}>
          <div className={styles.sideNavContent}>
            {this.selectedPage}
          </div>
          <div className={styles.sideNav}>
            <SvsSideNav {...this.props} />
          </div>
        </div>
        <SvsList {...this.props} />
      </div>
    );
  }
}


const mapStateToProps = ({ details: { detailsSvs } }: ApplicationState): PropsFromState => ({
  currentView: detailsSvs.currentView
});

export default connect(mapStateToProps)(withParams(Svs));
